var file = {
    download(response_content) {
        let file_content = response_content.data;
        const file_type = response_content.headers?.['content-type'] || 'application/octet-stream';
        const disposition = response_content.headers?.['content-disposition'] || '';
        const file_name = this.getFileName(disposition) || 'download';

        // Fix: when axios parses JSON, data is an object -> Blob becomes "[object Object]"
        if (
            file_content !== null &&
            typeof file_content === 'object' &&
            !(file_content instanceof Blob) &&
            !(file_content instanceof ArrayBuffer)
        ) {
            file_content = JSON.stringify(file_content, null, 2);
        }

        const blob = file_content instanceof Blob ? file_content : new Blob([file_content], { type: file_type });

        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);

        link.href = url;
        link.download = file_name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },
    getFileName(content_disposition) {
        if (!content_disposition) return '';

        let filename = '';
        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        let matches = filenameRegex.exec(content_disposition);

        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }

        return filename;
    },
};

export default file;
